const underscore = require('underscore');

/**
 * Prevents calling the callback more than once in a Limit amount of time
 * @param {function} func - Callback function
 * @param {Number} limit - Number of miliseconds to prevent the function call
 */
const throttle = (func, limit) => {
  let lastFunc;
  let lastRan;
  return function () {
    const context = this;
    const args = arguments;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(() => {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
};

const animateValue = (obj, start, end, duration) => {
  // assumes integer values for start and end
  function run(endTime, range, timer) {
    const now = new Date().getTime();
    const remaining = Math.max((endTime - now) / duration, 0);
    const value = Math.round(end - (remaining * range));

    // Fine because this is exactly what we want to achieve, change the HTML
    obj.innerHTML = value;
    if (value === end) {
      clearInterval(timer);
    }
  }
  if (
    obj
    && typeof (Number(start)) === 'number'
    && typeof (Number(end)) === 'number'
    && typeof (Number(duration)) === 'number'
  ) {
    const range = end - start;
    // no timer shorter than 50ms (not really visible any way)
    const minTimer = 50;
    // calc step time to show all interediate values
    let stepTime = Math.abs(Math.floor(duration / range));

    // never go below minTimer
    stepTime = Math.max(stepTime, minTimer);

    // get current time and calculate desired end time
    const startTime = new Date().getTime();
    const endTime = startTime + duration;
    let timer;

    // Es lint doesn't recognize this but we are passing it as a reference
    // and it does get overriden later.
    timer = setInterval(() => run(endTime, range, timer), stepTime);
    run(endTime, range, timer);
  }
};

/**
 * Replace string with given value
 * @typedef TransformObject
 * @type {Object}
 * @property {string} findString
 * @property {string} replaceWith
 * @param {string} output - sentence
 * @param {TransformObject} instruction - replace string with find/replace properties
 * @returns {string} - sentence with replaced text
 */
const replaceTextReduceCallback = (output, instruction) => {
  const defaultObject = {
    findString: '',
    replaceWith: '',
  };

  const { findString, replaceWith } = instruction || defaultObject;
  return output.replace(findString, replaceWith);
};

/**
 * Replace text inside sentence with given word
 * @param {string} sentence
 * @param  {Array.<TransformObject>} argumentObject - list of instruction objects
 */
const replaceTextWith = (sentence, ...argumentObject) => argumentObject.reduce(replaceTextReduceCallback, sentence);

/**
 * Validates source images
 * @param {string} imgSrc - image source
 * @param {function} successCallback
 * @param {function} errCallback
 */
const validateImage = (imgSrc, successCallback, errCallback) => {
  const image = new Image();
  image.src = imgSrc;
  image.onload = successCallback;
  image.onerror = errCallback;
};

/**
 * Round arrays values to match targeted value. This is used for polls where we need to show user
 * percentage of voted polls
 * @param {Array} dataArray Array to be rounded to match target
 * @param {Number} target this represents target value that array needs to match
 * @returns
 */
const roundArray = (dataArray, target) => {
  const off = target - underscore.reduce(dataArray, (acc, x) => acc + Math.round(x), 0);
  return underscore.chain(dataArray)
    .map((x, i) => Math.round(x) + (off > i) - (i >= (dataArray.length + off)))
    .value();
};

module.exports = {
  throttle,
  animateValue,
  replaceTextWith,
  validateImage,
  roundArray,
};
